module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_16.ab574fd6.png";